module.exports = __webpack_public_path__ + "static/media/weekly.59e4c212.svg";